import React from 'react';
import { sanitizeProductDescriptionHtml } from '../utils/sanitizeProductHtml';
import './ProductDescriptionHtml.css';

/**
 * Renders sanitized HTML product description on the storefront.
 */
const ProductDescriptionHtml = ({ html, className = '' }) => {
  const safe = sanitizeProductDescriptionHtml(html || '');
  if (!safe.trim()) return null;
  return (
    <div
      className={`product-description-html ${className}`.trim()}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
};

export default ProductDescriptionHtml;
